import { FC } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * WeekendNotification component displays a warning about potential withdrawal delays
 * during weekends. The notification is shown from Friday 4:00 PM until Sunday 11:59:59 PM
 * based on the user's browser local time.
 */
const WeekendNotification: FC = () => {
	const { t } = useTranslation()

	/**
	 * Check if the current time falls within the weekend notification period
	 * Friday 16:00 (4pm) - Sunday 23:59:59 (midnight)
	 */
	const shouldShowNotification = (): boolean => {
		const now = new Date()
		const dayOfWeek = now.getDay() // 0=Sunday, 1=Monday, ..., 5=Friday, 6=Saturday
		const hour = now.getHours()

		// Friday (5) after 4pm
		if (dayOfWeek === 5 && hour >= 16) {
			return true
		}

		// Saturday (6) all day
		if (dayOfWeek === 6) {
			return true
		}

		// Sunday (0) all day
		if (dayOfWeek === 0) {
			return true
		}

		return false
	}

	// Don't render anything if we're outside the weekend period
	if (!shouldShowNotification()) {
		return null
	}

	return (
		<div className={'flex gap-2 lg:gap-3 bg-orange-50 text-orange-700 p-3 lg:p-4 rounded-md shadow-md mb-4'}>
			<div className={'flex-shrink-0'}>
				<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={'mt-0.5'}>
					<path
						d='M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z'
						fill='currentColor'
					/>
				</svg>
			</div>
			<p className={'text-13 lg:text-14 font-400 leading-md'}>{t('loc:employee|Weekend withdrawal notice')}</p>
		</div>
	)
}

export default WeekendNotification
